webpackJsonp([10],{

/***/ 382:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var $ = __webpack_require__(5);
var form = __webpack_require__(28);

/**
 * Trim value, and eliminates internal spaces.
 */
function normalizeAuthenticationCode(value) {
	return value && value.trim().replace(' ', '');
}

function validate() {
	var errors = [];
	var username = $('[name=username]').val();
	if (!username) {
		errors.push(buildError('username', 'Campo obligatorio'));
	}

	var password = $('[name=password]').val();
	if (!password) {
		errors.push(buildError('password', 'Campo obligatorio'));
	}
	var $authCode = $('[name=authenticationCode]');
	if ($authCode.length) {
		var authenticationCode = $authCode.val();

		if (!authenticationCode) {
			errors.push(buildError('authenticationCode', 'Campo obligatorio'));
		} else {
			if (!/^[0-9]+$/.test(authenticationCode)) {
				errors.push(buildError('authenticationCode', 'Formato inválido (sólo dígitos)'));
			}
		}
	}
	return errors;
}

//[{ field: "nombre del campo", message: "mensaje de error", code: "código del mensaje" }]

function buildError(field, message) {
	return {
		field: field,
		message: message
	};
}

function showCapsLockWarning(show) {
	if (show) {
		$('#login-capsLockWarning').removeClass('invisible');
	} else {
		$('#login-capsLockWarning').addClass('invisible');
	}
}

var authenticationPreference = function () {
	var hostParts = window.location.hostname.split('.');
	hostParts.shift();
	var domain = hostParts.join('.');

	var pathname = window.location.pathname;

	var _pathname$split = pathname.split('/'),
	    _pathname$split2 = _slicedToArray(_pathname$split, 2),
	    context = _pathname$split2[1];

	var path = '/' + context;

	/**
  * Devuelve una cadena del tipo "expires=fechaGMT", dónde fechaGMT será una fecha
  * en formato GMT, calculada desde la fecha actual y sumando los segundos especificados
  * en el parámetro.
  * @param {number} seconds
  */
	function calculateExpires(seconds) {
		var date = new Date();
		date.setTime(date.getTime() + seconds * 1000);
		return "Expires=" + date.toGMTString();
	}

	var ONE_YEAR_IN_SECONDS = 365 * 24 * 60 * 60;

	return {
		retrieve: function retrieve() {
			var cookies = function cookies() {
				return document.cookie.split(';').reduce(function (a, c) {
					var _c$split = c.split('='),
					    _c$split2 = _slicedToArray(_c$split, 2),
					    k = _c$split2[0],
					    v = _c$split2[1];

					a[k.trim()] = v.trim();return a;
				}, {});
			}();
			return cookies['aemps.security.prefs.authentication-method'];
		},
		store: function store(method) {
			var expires = calculateExpires(ONE_YEAR_IN_SECONDS);
			document.cookie = 'aemps.security.prefs.authentication-method=' + method + ';Domain=' + domain + ';Path=' + path + ';' + expires + ';Max-Age=' + ONE_YEAR_IN_SECONDS + ';Secure;SameSite=Lax';
		}
	};
}();

function showLoginForm() {
	$('#section-wait').removeClass('d-flex').addClass('d-none');
	$('#section-seleccion').addClass('d-none');
	$('#section-login').removeClass('d-none');
	document.getElementById('username').focus();
}
function showAuthenticationMethod() {
	$('#section-wait').removeClass('d-flex').addClass('d-none');
	$('#section-seleccion').removeClass('d-none');
	$('#section-login').addClass('d-none');
}

function parseSearch(search) {
	if (!search || search.length === 0) {
		return {};
	}
	var params = (search.startsWith('?') ? search.substring(1) : search).split('&');
	var o = {};
	if (params.length) {
		params.forEach(function (p) {
			var _p$split = p.split('='),
			    _p$split2 = _slicedToArray(_p$split, 2),
			    key = _p$split2[0],
			    value = _p$split2[1];

			if (key.trim() !== '') {
				var parsedValue = value && value.trim();
				o[key] = parsedValue && decodeURIComponent(parsedValue);
			}
		});
	}
	return o;
}
function extractSearchParams() {
	return parseSearch(window.location.search);
}

$(function () {
	var preferedAuthenticationMethod = authenticationPreference.retrieve();
	var params = extractSearchParams();
	if (params.access) {
		preferedAuthenticationMethod = params.access;
		authenticationPreference.store(params.access);
	}

	switch (preferedAuthenticationMethod) {
		case 'verificationCode':
			if (window.location.href.startsWith(options.urlVerificationCode)) {
				showLoginForm();
			} else {
				window.location.href = options.urlVerificationCode + '/login' + window.location.search;
			}
			break;
		case 'certificate':
			if (window.location.href.startsWith(options.urlCertificate)) {
				showLoginForm();
			} else {
				window.location.href = options.urlCertificate + '/login' + window.location.search;
			}
			break;

		default:
			showAuthenticationMethod();
			break;
	}

	$('#bVerificationCode').click(function () {
		authenticationPreference.store('verificationCode');
		if (window.location.href.startsWith(options.urlVerificationCode)) {
			showLoginForm();
		} else {
			window.location.href = options.urlVerificationCode + '/login';
		}
	});
	$('#bCertificate').click(function () {
		authenticationPreference.store('certificate');
		if (window.location.href.startsWith(options.urlCertificate)) {
			showLoginForm();
		} else {
			window.location.href = options.urlCertificate + '/login';
		}
	});

	$('#alternateUrl').click(function (event) {
		var method = $(this).data('method');
		authenticationPreference.store(method);
	});

	$('[name=password]').on('keydown', function (event) {
		if (event.originalEvent.getModifierState) {
			var isCapsLock = event.originalEvent.getModifierState('CapsLock');
			showCapsLockWarning(isCapsLock);
		}
	}).on('blur', function () {
		showCapsLockWarning(false);
	});

	$('#aemps-security-form-login').submit(function (event) {
		form.removeErrors(this);
		var errors = validate();
		if (errors.length > 0) {
			form.showErrors(errors);
			event.preventDefault();
			return false;
		} else {
			var $form = $(this);
			$.ajax({
				dataType: "json",
				url: 'csrf'
			}).then(function (response) {
				var token = response.token;
				var paramName = response.parameterName;
				$form.find('input[name=' + paramName + ']').val(token);
				$form.get(0).submit();
			});
			event.preventDefault();
			return false;
		}
	});

	$('#totp').on("input keydown keyup mousedown mouseup select contextmenu drop", function () {
		if (/^\d*$/.test(this.value)) {
			// sólo dígitos
			this.oldValue = this.value;
			this.oldSelectionStart = this.selectionStart;
			this.oldSelectionEnd = this.selectionEnd;
		} else if (this.hasOwnProperty("oldValue")) {
			this.value = this.oldValue;
			this.setSelectionRange(this.oldSelectionStart, this.oldSelectionEnd);
		} else {
			this.value = "";
		}
	});
});

/***/ })

},[382]);


// WEBPACK FOOTER //
// aemps/login.206fa761ac159d5aa686.js